import * as React from 'react';

import classify from 'src/utils/classify';

import css from './one-line.css';

// TODO (kyle): this should probably share more code with `one-line.jsx`
export function MultiLineTextInput({
  className,
  autoFocus,
  ...props
}: {
  className?: string;
  autoFocus?: unknown;
  onChange?: (arg1: React.ChangeEvent<HTMLInputElement>) => unknown;
  onBlur?: (arg1: React.SyntheticEvent<HTMLInputElement>) => unknown;
  onKeyDown?: (arg1: React.KeyboardEvent<HTMLInputElement>) => unknown;
  value?: string;
  defaultValue?: string;
  placeholder?: string;
  disabled?: boolean;
  maxLength?: number;
}): React.ReactElement<React.ComponentProps<'textarea'>> {
  // @ts-expect-error - TS2554 - Expected 1 arguments, but got 0.
  const ref = React.useRef();
  React.useEffect(() => {
    if (autoFocus) {
      // @ts-expect-error - TS2339 - Property 'focus' does not exist on type '{}'.
      ref.current?.focus();
    }
  }, [autoFocus]);

  return (
    <textarea
      type="text"
      className={classify(css.multiLine, className)}
      // @ts-expect-error - TS2322 - Type 'RefObject<unknown>' is not assignable to type 'Ref<HTMLTextAreaElement> | undefined'.
      ref={ref}
      {...props}
    />
  );
}
export default MultiLineTextInput;
